import FluencyChart from './FluencyChart'
import { Column, Flex, Row, Text } from '@/components/core'
import { classNameBuilder } from '@/helpers'

type FluencyCardDataType = {
  speechRate: number
  articulationRate: number
}

interface FluencyCardProps {
  data: FluencyCardDataType
  isResponsive?: boolean
}

const FluencyCard = ({ data, isResponsive = true }: FluencyCardProps) => {
  return (
    <Flex
      className={classNameBuilder(
        'w-full flex-col space-y-8 border border-gray-50 bg-white p-10 ',
        isResponsive && 'max-lg:border-0 max-lg:p-6 lg:rounded-2xl',
        !isResponsive && 'rounded-2xl'
      )}
    >
      <Row
        className={classNameBuilder(
          'w-full flex-wrap items-center',
          isResponsive &&
            'max-lg:justify-center max-lg:space-y-4 lg:justify-between',
          !isResponsive && 'justify-between'
        )}
      >
        <Column
          className={classNameBuilder(
            'flex-1 space-y-1',
            isResponsive && 'max-lg:items-center'
          )}
        >
          <Text.Translated
            fontWeight="bold"
            color="600"
            translationKey="speech_speed_fluency_card"
          />
          <Text.Translated
            size="xs"
            className={classNameBuilder(isResponsive && 'max-lg:text-center')}
            translationKey="speech_speed_description_fluency_card"
          />
        </Column>
        <FluencyChart data={{ type: 'speech', value: data?.speechRate || 0 }} />
      </Row>
      <Row className="h-[1px] w-full bg-gray-50" />
      <Row
        className={classNameBuilder(
          'w-full flex-wrap items-center ',
          isResponsive &&
            'max-lg:justify-center max-lg:space-y-4 lg:justify-between',
          !isResponsive && 'justify-between'
        )}
      >
        <Column
          className={classNameBuilder(
            'flex-1 space-y-1',
            isResponsive && 'max-lg:items-center'
          )}
        >
          <Text.Translated
            fontWeight="bold"
            color="600"
            className={classNameBuilder(isResponsive && 'max-lg:text-center')}
            translationKey="articulation_speed_fluency_card"
          />
          <Text.Translated
            size="xs"
            className={classNameBuilder(isResponsive && 'max-lg:text-center')}
            translationKey="articulation_speed_description_fluency_card"
          />
        </Column>
        <FluencyChart
          data={{ type: 'articulation', value: data?.articulationRate || 0 }}
        />
      </Row>
    </Flex>
  )
}

export default FluencyCard
